/*------------------------------------*\
    MODULES
\*------------------------------------*/
import Fuse from 'fuse.js';
import $ from "jquery";

/*------------------------------------*\
    SEARCH
\*------------------------------------*/
class DocumentSearch {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;

        self.searchInput = self.elem.querySelectorAll('[data-document-search-input]');
        self.searchResults = self.elem.querySelectorAll('[data-document-search-results]');
    }

    init() {
        let self = this;

        let resultsContainer = $(self.searchResults);

        $.getJSON('/document-search.json', function (response) {
            console.log('document search json');

            const fuse = new Fuse(response, {
                keys: [
                    {
                        name: 'title',
                        weight: 3
                    }
                ],
                ignoreLocation: true,
                threshold: 0.0
            });

            $(self.searchInput).on('keyup', function () {

                let result = fuse.search($(this).val());

                if ($(this).val().length === 0) {
                    resultsContainer.hide();
                    resultsContainer.addClass('d-none');
                }

                if (result.length === 0) {
                    resultsContainer.empty();
                    resultsContainer.removeClass('d-none');

                    resultsContainer.append('<p class="p-3 m-0 text-dark">There are no documents matching your search</p>');
                } else {
                    resultsContainer.empty();
                    resultsContainer.removeClass('d-none');

                    for (let search in result.slice(0, 8)) {
                        //let searchItem = '<a class="document-search__results-item" href="' + result[search].item.path + '"><span class="document-search__results-item-link">' + result[search].item.title + '</span></a>';

                        let searchItem = `
                        <div class="[ list-downloads ]">
                            <div class="[ list-downloads__document ]">
                                <span class="[ list-downloads__document__icon ]">
                                    <span class="[ list-downloads__icon ]"></span>
                                </span>

                                <div>
                                    <a class="[ text-blue-500 ]" target="_blank" href="${result[search].item.url}">${result[search].item.title}:</a>

                                    <span class="[ list-downloads__document__note ]">${result[search].item.description}</span>

                                    <ul class="[ list-downloads ]">
                                        <li class="[ mt-1 ]">
                                            <span class="[ list-downloads__document__note ]">${result[search].item.size} | ${result[search].item.date}</span>
                                        </li>
                                    </ul>

                                    <a target="_blank" class="[ btn btn--small ] [ mt-2 ]" href="${result[search].item.url}">Download</a>
                                </div>
                            </div>
                        </div>
                        `

                        resultsContainer.append(searchItem);
                    }

                    resultsContainer.show();
                }
            });
        });
    }
}

export default DocumentSearch;